module.exports = __webpack_public_path__ + "static/media/mentalia-test-logo-short.a1afe956.svg";